import { Button, ButtonChips, Loader, Text } from 'components';
import { DefaultLoadingContainer } from 'components/Loader/Loader.style';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BottomBar, MenuHomeContainer } from './MenuHome.style';
import ProductList from './ProductList';
import { useMenuHomeVM } from './useMenuHomeVm';

const MenuHome: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const {
        isError,
        isFetching,
        data,
        currency,
        productCount,
        amountWithCurrency,
        navigateToProduct,
        navigateToCart,
    } = useMenuHomeVM();

    if (isFetching) {
        return (
            <DefaultLoadingContainer>
                <Loader size={50} />
            </DefaultLoadingContainer>
        );
    }
    if (isError) {
        return <h1>{t('loading_menu_error')}...</h1>;
    }

    const categories = Object.values(data?.categories ?? []);

    return (
        <MenuHomeContainer>
            {categories
                .filter(
                    ({ webAvailability, products }) =>
                        webAvailability && Object.values(products).length,
                )
                .map((cat) => (
                    <ProductList
                        key={cat.categoryId}
                        productList={Object.values(cat.products)}
                        title={cat.name}
                        currency={currency}
                        onProductClick={navigateToProduct}
                    />
                ))}

            <BottomBar>
                <Button fullWidth onClick={navigateToCart}>
                    <ButtonChips>{productCount}</ButtonChips>
                    <Text
                        text={'button_show_basket'}
                        values={{
                            amount: amountWithCurrency,
                        }}
                        weight="bold"
                    />
                </Button>
            </BottomBar>
        </MenuHomeContainer>
    );
};

export default MenuHome;
